export default __webpack_public_path__ + "static/media/warning--double-descent--g1.4470eef4.png";